import { useContext } from 'react';
import { ToastContext } from 'context/ToastContext';
export const useToast = () => {
  const context = useContext(ToastContext);

  if (!context) {
    return {
      toastList: [],
      setToastList: undefined,
    };
  }

  return context;
};
